import * as axiosConfig from '@/axios.config.lib';

export const locationProtocol = document.location.protocol;
export const locationHostname = document.location.hostname;
export const locationPort = document.location.port;

// locationOrigin Without port.
export const locationOrigin = `${locationProtocol}//${locationHostname}`;

export const appDomain = axiosConfig.env(locationHostname)['domain'];
export const appEnv = axiosConfig.env(locationHostname)['env'];
